import { useEffect, useState } from "react"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"
import tw, { styled } from "twin.macro"

import Icons from "@components/v2/Icons"

interface WrapperProps {
    active: boolean
}

const Wrapper = styled.div<WrapperProps>`
    ${tw`h-0`}
    ${tw`invisible overflow-hidden`}
    ${tw`flex flex-row items-center justify-center gap-1`}
    ${tw`text-sm font-bold text-[#BE2C53] dark:text-[#FF6E88]`}
    ${tw`bg-[#FDEBF0] dark:bg-[#550D1A]`}
    ${tw`transition-all duration-300`}

    ${({ active }) => active && tw`h-7 visible`}
`

interface Props {
    onChange?: (value: boolean) => void
}

const InternetAlert: React.FC<Props> = ({ onChange }) => {
    const { t } = useTranslation()
    const [isOffline, setOffline] = useState(false)
    const router = useRouter()

    useEffect(() => {
        const handleConnectionChange = () => {
            const status = navigator.onLine ? "online" : "offline"

            if (status === "online") {
                setOffline(false)
                onChange?.(false)
            } else {
                setOffline(true)
                onChange?.(true)
            }
        }

        window.addEventListener("online", handleConnectionChange)
        window.addEventListener("offline", handleConnectionChange)

        return () => {
            window.removeEventListener("online", handleConnectionChange)
            window.removeEventListener("offline", handleConnectionChange)
        }
    }, [])

    if (router.asPath === "/") {
        return null
    }

    return (
        <Wrapper active={isOffline}>
            <Icons icon='Wifi' />
            {t("components:internet_alert")}
        </Wrapper>
    )
}

export default InternetAlert
